import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import usePromotionDetails from './promotion-details.hook';
import PromotionForm from './components/promotionForm';

export default function PromotionDetails() {
  const {
    isEdit,
    isLoadingPromotionDetails,
    methods,
    isValidEndDate,
    isValidExhibitionEndDate,
    onSubmit,
    handleDrop,
    handleDropMultiple,
    handleRemove,
    handleRemoveAll,
    control,
    values,
    isSubmitting,
    STATUS_LABEL,
    STATUS_OPTIONS,
    TIERS_OPTIONS,
  } = usePromotionDetails();
  return (
    <Page title={isEdit ? 'Editar Sorteio' : 'Cadastrar Sorteio'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading={isEdit ? 'Editar Sorteio' : 'Cadastrar Sorteio'} links={[]} />
        {isLoadingPromotionDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <PromotionForm
            methods={methods}
            onSubmit={onSubmit}
            handleDrop={handleDrop}
            handleDropMultiple={handleDropMultiple}
            values={values}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            handleRemove={handleRemove}
            handleRemoveAll={handleRemoveAll}
            statusOptions={STATUS_OPTIONS}
            statuslabel={STATUS_LABEL}
            tierOptions={TIERS_OPTIONS}
            control={control}
            isValidEndDate={isValidEndDate}
            isValidExhibitionEndDate={isValidExhibitionEndDate}
          />
        )}
      </Container>
    </Page>
  );
}
